module.exports = __webpack_public_path__ + "img/sfks2-2.31f626a9.png";